export default __webpack_public_path__ + "static/media/bz.152abd8d.svg";